/* poa-reveal — opt-in scroll reveal utility for any [data-poa-reveal] element.
   Fade-in + slide-up on viewport entry, fires once per element.
   Stagger via [data-poa-reveal-stagger] parent → children get --poa-d index.
   prefers-reduced-motion: reduce → no animation, elements appear at final state.
   Namespaced window.PoAReveal, idempotent, instance-scoped, morph-safe. */
(function () {
  'use strict';
  if (window.PoAReveal && window.PoAReveal._loaded) return;

  var reduce = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      var en = entries[i];
      if (en.isIntersecting) {
        en.target.classList.remove('poa-reveal--pending');
        io.unobserve(en.target);
      }
    }
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }) : null;

  function applyStagger(scope) {
    var staggers = (scope || document).querySelectorAll(
      '[data-poa-reveal-stagger]:not([data-poa-stg-init])'
    );
    for (var s = 0; s < staggers.length; s++) {
      var st = staggers[s];
      st.setAttribute('data-poa-stg-init', '1');
      var kids = st.querySelectorAll('[data-poa-reveal]');
      for (var k = 0; k < kids.length; k++) {
        kids[k].style.setProperty('--poa-d', k);
      }
    }
  }

  function init(scope) {
    applyStagger(scope);
    var nodes = (scope || document).querySelectorAll(
      '[data-poa-reveal]:not([data-poa-rv-init])'
    );
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      n.setAttribute('data-poa-rv-init', '1');
      if (reduce || !io) continue; // already in final state via CSS fallback
      n.classList.add('poa-reveal--pending');
      io.observe(n);
    }
  }

  window.PoAReveal = { init: init, _loaded: true };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Survive Section Rendering API morph re-renders.
  document.addEventListener('shopify:section:load', function (e) {
    if (e && e.target) init(e.target);
  });
})();
